import {
  BpkBox,
  BpkSpacing,
  BpkVessel,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';

import currentLandingPagesOptions from '../../utils/richTextBrandStyles';
import HTMLWrapper from '../HTMLWrapper';
import RichText from '../RichText';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { Document } from '@contentful/rich-text-types';
import type { TextProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/Text';

const Text = (props: TextProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  const { componentName, content, html, subtitle, title } = props;
  const uniqueId = componentName ?? '';
  const contentArray = Array.isArray(content) ? content : [];
  const contentHtml =
    typeof content === 'string'
      ? content
      : (contentArray as Array<string | Document>).filter(
          (item): item is string => typeof item === 'string',
        );
  const richText = (contentArray as Array<string | Document>).filter(
    (item): item is Document => typeof item === 'object' && 'nodeType' in item,
  );

  if (richText?.length > 0) {
    return (
      // maxWidth mirrors `falcon-text-component-max-width` (97 * spacing-md (0.5rem) = 48.5rem)
      <BpkBox
        maxWidth="48.5rem"
        data-tracking-element-id={rawComponentName}
        data-tracking-common-params={buildMBDParam(rawComponentName)}
      >
        {!!title && (
          <BpkBox marginBottom={BpkSpacing.LG}>
            <BpkSectionHeader title={title} description={subtitle} />
          </BpkBox>
        )}
        {/* BpkVessel (not BpkBox): BpkBox cannot take a className, and the global
            `text` class must be kept. CASTLE-4815 (programmatic rich text) is
            expected to render via `Text_Text div.text`, so e2e helpers may
            target this selector. */}
        <BpkVessel id={uniqueId} className="text">
          {richText.map((item) => (
            <RichText
              key={String(JSON.stringify(item))}
              body={item}
              options={currentLandingPagesOptions}
            />
          ))}
        </BpkVessel>
      </BpkBox>
    );
  }

  if (contentHtml?.length > 0) {
    return (
      <HTMLWrapper
        content={contentHtml}
        title={html?.title}
        subtitle={subtitle}
        componentName={uniqueId}
      />
    );
  }

  return null;
};

export default Text;
